// eslint-disable-next-line base/no-restricted-imports/uuid -- use v4 so that trace ids look distinct
import { v4 } from "uuid";

export function createTraceId(): string {
  return v4();
}
